// YouTubeIcon.jsx
import React from 'react';
import Icon from './yt_icon_rgb.png';  // Adjust path as needed

const YoutubeIcon = ({ className = '' }) => (
    <img
        src={Icon}
        alt="YouTube"
        className={`min-h-[20px] ${className}`}
        style={{ objectFit: 'contain' }}
    />
);

export default YoutubeIcon;
